export default __webpack_public_path__ + "static/media/Screenshot (1175).fc8f9a7f.png";